enum SplitFeature {
  NewDocumentMetadataApi = 'NEW_DOCUMENT_METADATA_API',
  ThirdPartyAccess = 'THIRD_PARTY_ACCESS',
  PdmsBulkUpload = 'PDMS_BULK_UPLOAD',
}

export { SplitFeature };
